export default function formatMediaFileAddedDate({ createdAtMs, locale }: { createdAtMs: number; locale: string }): string {
  return new Intl.DateTimeFormat(locale, {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(createdAtMs);
}
